var colorArray = $(".color-array");
if (colorArray && colorArray[0]) {
    var arrayColor = colorArray[0];
    var colorList = arrayColor.innerText;
    colorList = colorList.split(",");
}

var lis = $(".investment-process-content h6 ");
for (var i = 0; i < lis.length; i++) {
    var color = "#016FAD";
    if (colorList && colorList[i]) {
        color = colorList[i];
    }
    lis[i].insertAdjacentHTML(
        "beforebegin",
        '<div style="width:8px; height:8px; margin-bottom:-20px; margin-right:0px; background:' + color + ';"></div>',
    );
}
